<template>
    <div class="statistic">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="statistic_top">
                        <div class="left">
                            <h3>Статистик</h3>
                        </div>
                        <div class="right">
                            <ul>
<!--                                <li>Нийт: {{total | number}}</li>-->
                                <li>
                                    <div class="select">
                                        <Input @on-search="calldata"  search enter-button placeholder="Хайх..." v-model="searchWord"/>
                                    </div>

                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                  <div class="statistic_table">
                      <table width="100%">
                          <thead>
                          <tr>
                              <th>№</th>
                              <th>СТАТИСТИК МЭДЭЭ</th>
                              <th>ОГНОО</th>
                              <th></th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr :key="index" v-for="(statistic, index) in statistics">
                              <td>
                                  <span v-if="current_page == 1">{{index+1}}</span>
                                  <span v-else>{{((current_page-1)*9)+(index+1)}}</span>
                              </td>
                              <td>{{statistic.storol}}</td>
                              <td>{{statistic.ognoo | date}}</td>
                              <td><a :href="statistic.file" target="_blank" class="button">Үзэх</a></td>
                          </tr>

                          </tbody>
                      </table>
                  </div>
              </div>
            </div>

            <div class="row">
                <div class="col-2">
                    <div class="total">Нийт: {{total | number}}</div>
                </div>
                <div class="col-10">
                    <div class="statistic_page">
                        <Page  @on-change="changePage"
                               :current-page="current_page"
                               :page-size="9"
                               :total="total"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getStatisticByCategory,} from "../api/index";

    export default {

        components: {

        },
        data () {
            return {
                statistics: [],
                current_page:1,
                last_page:1,
                total: 0,
                searchWord:null
            }
        },
        mounted () {
            this.calldata();
        },
        methods: {
            calldata(){
                this.$isLoading(true);
                // getStatistic(this.current_page, {searchWord:this.searchWord}).then(response=>{
                //     this.statistics = response.data.data;
                //     this.current_page = response.data.current_page;
                //     this.total = response.data.total;
                //     this.$isLoading(false);
                //     console.log(this.current_page);
                // }).catch(error => {
                //     this.$Loading.error();
                //     console.log('ErrorL ', error);
                // });
                this.$isLoading(true);
                getStatisticByCategory(this.torol_id, {searchWord:this.searchWord}).then(response=>{

                    this.statistics = response.data.data;
                    this.current_page = response.data.current_page;
                    this.total = response.data.total;
                    this.$isLoading(false);
                    // console.log(this.$route.params.torol_id);
                    // console.log("this.statistics");
                    // console.log(this.statistics);

                }).catch(error => {
                    this.$Loading.error();
                    console.log('ErrorL ', error);
                });
            },
            changePage(page) {
                this.current_page = page;
                this.calldata();
            },

        },
    }
</script>
